<ng-template #menuPanel let-field="field">

  <div class="main-actions">
    <button (click)="addMenu(field)" class="ibexfusion-raised-button" mat-button>
      {{'dynamicContent.gastro.addMenu' | translate}}
    </button>
  </div>

  <div class="action-header" [ngClass]="{ active: !!selectedItemsByField[field]?.length }">
    <div class="count">{{selectedItemsByField[field]?.length}} {{'general.selectedEntries' + (selectedItemsByField[field]?.length > 1 ? 'Multi' : 'Single') | translate}}</div>

    <mat-form-field *ngIf="checkBoxActions[field]" >
      <mat-select [disabled]="!selectedItemsByField[field]?.length" [placeholder]="'general.selectionActions' | translate">
        <mat-option (click)="action.action()" *ngFor="let action of checkBoxActions[field]">
          <mat-icon *ngIf="action.icon">{{action.icon}}</mat-icon>
          {{action.translation | translate}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

    <div class="table-header">
      <ibex-checkbox #checkboxAll [id]="'checkboxAll'" (click)="selectItemsAll(field)"></ibex-checkbox>
      <div class="title">{{'general.title' | translate}}</div>
      <div class="drag">
        <mat-icon>keyboard_arrow_up</mat-icon>
        <mat-icon>keyboard_arrow_down</mat-icon>
      </div>
      <div class="actions"></div>
    </div>

    <div (cdkDropListDropped)="dropItem($event, field)" cdkDropList class="table">
      <div *ngFor="let menu of dynamicContent.content[field]; let i = index" cdkDrag [cdkDragDisabled]="dynamicContent.content[field]?.length <= 1" cdkDragBoundary=".table" class="table-row">
        <div *cdkDragPlaceholder class="drag-placeholder"></div>
        <ibex-checkbox (click)="selectItem(menu, field)" [class]="field"></ibex-checkbox>
         <div class="title">{{ menu.title }}</div>
        <div class="drag">
          <button class="drag ibexfusion-icon-button" mat-icon-button matTooltip="{{'packages.installedApps.dragTip'| translate}}">
            <mat-icon>drag_indicator</mat-icon>
          </button>
        </div>
        <div class="actions">
          <button (click)="editMenu(field, i)" class="ibexfusion-icon-button" mat-icon-button>
            <mat-icon>edit</mat-icon>
          </button>
          <button (click)="removeMenu(field, i)" class="ibexfusion-icon-button" mat-icon-button>
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </div>
</ng-template>

<ng-container *ngIf="!isMain && !!dynamicContent">
  <mat-card appearance="outlined">
    <mat-form-field>
      <input (change)="checkDate($event)" (dateChange)="checkDate($event)" [matDatepicker]="startPicker" [disabled]="!create"
             [value]="dynamicContent.content.date" matInput placeholder="{{'dynamicContent.date' | translate}}">
      <mat-datepicker-toggle [for]="startPicker" matPrefix></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>
  </mat-card>
  <mat-card appearance="outlined">
    <h2>{{ 'dynamicContent.gastro.lunch' | translate }}</h2>
    <ng-container *ngTemplateOutlet="menuPanel;context:{ field: 'lunch' }"></ng-container>
  </mat-card>

  <mat-card appearance="outlined">
    <h2>{{ 'dynamicContent.gastro.dinner' | translate }}</h2>
    <ng-container *ngTemplateOutlet="menuPanel;context:{ field: 'dinner' }"></ng-container>
  </mat-card>

  <mat-card appearance="outlined">
    <h2>{{ 'dynamicContent.gastro.hits' | translate }}</h2>
    <ng-container *ngTemplateOutlet="menuPanel;context:{ field: 'hots' }"></ng-container>
  </mat-card>
</ng-container>

<mat-card appearance="outlined" *ngIf="isMain">
  <div class="title-container">
    <smart-input (onChange)="change($event, 'title')" [hideDescription]="true" [key]="'title'"
                 [model]="dynamicContent" translationKey="dynamicContent.gastro.title"></smart-input>
    <smart-input (onChange)="change($event, 'separator', true)" [hideDescription]="true" [key]="'separator'"
                 [model]="dynamicContent.content" translationKey="dynamicContent.gastro.separator"></smart-input>
  </div>
  <smart-input (onChange)="change($event, 'disclaimer', true)" [hideDescription]="true" [key]="'disclaimer'"
               [model]="dynamicContent.content" translationKey="dynamicContent.gastro.disclaimer" height="150px"></smart-input>
</mat-card>
<mat-card  appearance="outlined"  *ngIf="isMain">
  <h2>{{ 'dynamicContent.gastro.timeWindow' | translate }}</h2>
  <div class="time-window-container">
    <div class="time-window">
      <h3>{{ 'dynamicContent.gastro.lunch' | translate }}</h3>
      <div class="input-container">
        <smart-input (onChange)="change($event, 'lunchStartTime', true)" [hideDescription]="true" [key]="'lunchStartTime'"
                     [model]="dynamicContent.content" translationKey="dynamicContent.gastro.from"></smart-input>
        <smart-input (onChange)="change($event, 'lunchEndTime', true)" [hideDescription]="true" [key]="'lunchEndTime'"
                     [model]="dynamicContent.content" translationKey="dynamicContent.gastro.to"></smart-input>
      </div>
    </div>
    <div class="time-window">
      <h3>{{ 'dynamicContent.gastro.dinner' | translate }}</h3>
      <div class="input-container">
        <smart-input (onChange)="change($event, 'dinnerStartTime', true)" [hideDescription]="true" [key]="'dinnerStartTime'"
                     [model]="dynamicContent.content" translationKey="dynamicContent.gastro.from"></smart-input>
        <smart-input (onChange)="change($event, 'dinnerEndTime', true)" [hideDescription]="true" [key]="'dinnerEndTime'"
                     [model]="dynamicContent.content" translationKey="dynamicContent.gastro.to"></smart-input>
      </div>
    </div>
  </div>

  <div class="time-window-container">
    <div class="time-window">
      <h3>{{ 'dynamicContent.gastro.lunchOrder' | translate }}</h3>
      <div class="input-container">
        <smart-input (onChange)="change($event, 'lunchOrderStartTime', true)" [hideDescription]="true" [key]="'lunchOrderStartTime'"
                     [model]="dynamicContent.content" translationKey="dynamicContent.gastro.from"></smart-input>
        <smart-input (onChange)="change($event, 'lunchOrderEndTime', true)" [hideDescription]="true" [key]="'lunchOrderEndTime'"
                     [model]="dynamicContent.content" translationKey="dynamicContent.gastro.to"></smart-input>
      </div>
    </div>
    <div class="time-window">
      <h3>{{ 'dynamicContent.gastro.dinnerOrder' | translate }}</h3>
      <div class="input-container">
        <smart-input (onChange)="change($event, 'dinnerOrderStartTime', true)" [hideDescription]="true" [key]="'dinnerOrderStartTime'"
                     [model]="dynamicContent.content" translationKey="dynamicContent.gastro.from"></smart-input>
        <smart-input (onChange)="change($event, 'dinnerOrderEndTime', true)" [hideDescription]="true" [key]="'dinnerOrderEndTime'"
                     [model]="dynamicContent.content" translationKey="dynamicContent.gastro.to"></smart-input>
      </div>
    </div>
  </div>
</mat-card>
